<script setup>
import {defineProps} from "vue";
import { WatchLinkApi } from "@/api/watch_links";
import { notify } from "@kyvg/vue3-notification";

const props = defineProps({
  link_id: {
    type: Number,
    required: true
  },
  project_id: {
    type: Number,
    required: true
  },
  css_class: {
    type: String,
    required: false
  }
});

const addLinkWatch = () => {
  WatchLinkApi.add({
    link_id: props.link_id,
    project_id: props.project_id
  }).then(() => {
    notify({
      type: 'success',
      text: 'Добавлено в раздел "Проверка позиций ссылок"'
    });
  });
};
</script>
<template>
  <button @click="addLinkWatch" :class="'btn btn-sm btn-outline-dark '+css_class" title="Добавить в проверку позиций">
    <i class="bi bi-plus"></i>
  </button>
</template>
<style scoped lang="scss">
  button {
    width: 20px!important;
    height: 20px!important;
    padding: 0!important;
    &.big{
      width: 35px!important;
    height: 35px!important;
    padding: 0!important;
    }
  }
</style>
